/**
 * fix-60 · ADR-018: inmobiliaria destino elegida por el superadmin en el selector. `null` = la de la
 * sesión. `api-client` la envía como `X-Inmobiliaria-Id` SOLO en las llamadas administrativas; el back
 * la acepta solo con `plataforma.gestionar_inmobiliarias`. Módulo aparte para que el estado no dependa
 * del objeto `apiClient` (que las pruebas de páginas simulan).
 */
let inmobiliariaActiva: string | null = null;

export const ENCABEZADO_INMOBILIARIA = 'X-Inmobiliaria-Id';

export function setInmobiliariaActiva(id: string | null): void {
  inmobiliariaActiva = id;
}

export function getInmobiliariaActiva(): string | null {
  return inmobiliariaActiva;
}
